import { READ_WORKED_IN_LAST_30_DAYS_FILTERS_FAILURE, READ_WORKED_IN_LAST_30_DAYS_FILTERS_REQUEST, READ_WORKED_IN_LAST_30_DAYS_FILTERS_SUCCESS, WorkedInLast30DaysFiltersActionTypes, WorkedInLast30DaysFiltersState } from 'store/reducers/types/workedInLast30Days/workedInLast30DaysFilters';

const defaultState: WorkedInLast30DaysFiltersState = {
  isLoading: false,
  errorMessage: ""
};

export default function workedInLast30DaysFilters(state = defaultState, action: WorkedInLast30DaysFiltersActionTypes): WorkedInLast30DaysFiltersState {
  switch (action.type) {
    case READ_WORKED_IN_LAST_30_DAYS_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_WORKED_IN_LAST_30_DAYS_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_WORKED_IN_LAST_30_DAYS_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};